import rateInformation from '@/api/rate-information'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  currencies: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_CURRENCIES(state, data) {
    state.currencies = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return rateInformation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return rateInformation.store(data)
  },

  update(context, data) {
    return rateInformation.update(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await rateInformation.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  delete(context, id) {
    return rateInformation.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.currencies.length > 0) {
      let response = await rateInformation.currency()
      context.commit('SET_CURRENCIES', response.data)
    }
  }
}
